@if (trafficDeviationStatus$ | async; as status) {
  @if (status >= 4) {
    <div class="status-failed">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <p translate>TrafficDeviationReceiptStatusFailed</p>
    </div>
  }
}